// import { ApexOptions } from "apexcharts";
// import ReactApexChart from "react-apexcharts";

const OnPremCircle = ({ score }: { score: number }) => {
  const getScoreColor = (score: number): string => {
    if (score >= 70) return "#4CAF50"; 
    if (score >= 40) return "#FF9800"; 
    return "#F44336";
  };

  const size = 100;
    const strokeWidth = 8
    const radius = (size - strokeWidth) / 2;
   const circumference = 2 * Math.PI * radius;
   const offset = circumference - (score / 100) * circumference;

// const chartOptions: ApexOptions = {
//     chart: {
//         height: 120,
//         type: "radialBar",
//         toolbar: {
//             show: false,
//         },
//         background: "transparent",
//     },
//     plotOptions: {
//         radialBar: {
//             hollow: {
//                 margin: 0,
//                 size: "65%",
//                 background: "transparent",
//             },
//             track: {
//                 background: "#e7e7e7",
//                 strokeWidth: "120%",
//             },
//             dataLabels: {
//                 name: {
//                     show: false,
//                 },
//                 value: {
//                     offsetY: 8,
//                     fontSize: "22px",
//                     fontWeight: 600,
//                     color: getScoreColor(score),
//                     formatter: function (val: number) {
//                         return val.toString();
//                     },
//                 },
//             },
//         },
//     },
//     fill: {
//         type: "gradient",
//         gradient: {
//             shade: "dark",
//             type: "horizontal",
//             shadeIntensity: 0.5,
//             gradientToColors: [getScoreColor(score)],
//             inverseColors: false,
//             opacityFrom: 1,
//             opacityTo: 0.8,
//             stops: [0, 100],
//         },
//     },
//     stroke: {
//         lineCap: "round",
//         colors: [getScoreColor(score)],  
//     },
//     colors: [getScoreColor(score)],
//     series: [score],
//     labels: [""],
// };

//   return (
//     <ReactApexChart
//       options={chartOptions}
//       series={chartOptions.series}
//       type="radialBar"
//       height={120}
//     />
//   );
 return (
    <div style={{ width: 100, height: 100 }}>
    <svg width={size} height={size}>
      <circle
        stroke="#f0f0f5"
        fill="transparent"
        strokeWidth={strokeWidth}
        r={radius}
        cx={size / 2}
        cy={size / 2}
      />
      <circle
        stroke={getScoreColor(score)}
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        r={radius}
        cx={size / 2}
        cy={size / 2}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="20"
        fontWeight="bold"
        fill={getScoreColor(score)}
      >
        {score}
      </text>
    </svg>
  </div>
 );
};

export default OnPremCircle;